
<div class="container">
  <app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center top-16 gap-3">
    <h2>Extrato de Desligamento Previdenciário</h2>
    
    <vivest-button variant="outline" size="md" (click)="download()">
      <vivest-icon slot="icon-right" name="download" source="feather"></vivest-icon>
      Baixar Extrato de Desligamento (.pdf)
    </vivest-button>
  </div>
  
  <app-pdf-document
    class="top-32"
    [src]="pdfSrc()"
    [textoInformativo]="textoVisualizado()"
  ></app-pdf-document>
  
  <div class="d-flex justify-content-center align-items-center buttons top-32">
    <vivest-button variant="outline" size="md" (click)="onReturn()">
      Voltar
    </vivest-button>
    <vivest-button variant="primary" size="md" (click)="onSubmit()">
      <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
      Escolher Instituto Previdenciário
    </vivest-button>
  </div>
</div>
